import { render } from "./LabelMenuItem.vue?vue&type=template&id=75b1f686&scoped=true"
import script from "./LabelMenuItem.vue?vue&type=script&lang=js"
export * from "./LabelMenuItem.vue?vue&type=script&lang=js"

import "./LabelMenuItem.vue?vue&type=style&index=0&id=75b1f686&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b1f686"]])

export default __exports__